export const detectCollisions = (sleeves: any[]) => {
    if (!sleeves) return new Set<string>();
    const hit = new Set<string>();

    for (let i = 0; i < sleeves.length; i++) {
        for (let j = i + 1; j < sleeves.length; j++) {
            if (detectCollision(sleeves[i], sleeves[j]))
            {
                hit.add(sleeves[i].id);
                hit.add(sleeves[j].id);
            }
        }
    }
    return hit;
};

export const detectCollision = (a: any, b: any): boolean => {
        const dx = a.x - b.x;
        const dy = a.y - b.y;
        const rSum = (a.diameter + b.diameter) / 2;
        if (dx * dx + dy * dy < rSum * rSum) {
            return true;
        }
        return false;
    }
;
